import { Switch, Route, Router as WouterRouter, Redirect } from "wouter";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import NotFound from "@/pages/not-found";
import ChatPage from "./pages/chat";
import PreviewChatPage from "./pages/preview-chat";
import MultipleChoicePage from "./pages/multiple-choice";
import AdminPage from "./pages/admin";
import AssessmentsPage from "./pages/assessments";
import AssessmentDetailPage from "./pages/assessment-detail";
import FeedbackPage from "./pages/feedback";
import FeedbacksPage from "./pages/feedbacks";
import { AdminAuthProvider } from "@/contexts/admin-auth";

const queryClient = new QueryClient();

function Router() {
  return (
    <Switch>
      <Route path="/" component={() => <Redirect to="/admin/api-keys" />} />
      <Route path="/preview-chat" component={PreviewChatPage} />
      <Route path="/chat" component={ChatPage} />
      <Route path="/chat/:assessmentToken" component={ChatPage} />
      <Route path="/mc/:assessmentToken" component={MultipleChoicePage} />
      <Route path="/admin/api-keys" component={AdminPage} />
      <Route path="/admin/assessments/:assessmentId" component={AssessmentDetailPage} />
      <Route path="/admin/assessments" component={AssessmentsPage} />
      <Route path="/admin/feedbacks" component={FeedbacksPage} />
      <Route path="/feedback" component={FeedbackPage} />
      <Route component={NotFound} />
    </Switch>
  );
}

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <AdminAuthProvider>
          <WouterRouter base={import.meta.env.BASE_URL.replace(/\/$/, "")}>
            <Router />
          </WouterRouter>
        </AdminAuthProvider>
        <Toaster />
      </TooltipProvider>
    </QueryClientProvider>
  );
}
